import { ReadAutomationsCriteria } from 'adapter/out/client/automations/readAutomationsApiClient';
import { Automation } from 'domain/entity/automation';
import getGenericUseCase from 'use-case/genericUseCase';

const readAutomationsUseCase = getGenericUseCase<Automation[], ReadAutomationsCriteria>((client, criteria) => client(criteria));

export default readAutomationsUseCase;
